import { ProductCompareValue } from "@nitro/gatsby-source-harvia-pim/helpers/attribute"
import { Product } from "gatsby-source-harvia-pim/types/plugin"
import React, { useContext } from "react"
import { PageContext } from "../../../context/PageContext"
import useDatoMicrocopy from "../../../hooks/useDatoMicrocopy"
import useProductPath from "../../../hooks/useProductPath"
import ProductAttribute from "./ProductAttribute"
import * as styles from "./ProductDataTable.module.scss"

type ProductDataTableProps = {
  values: ProductCompareValue[]
  products: Product[]
} //{ products: Product[]; keys: string[] }

const ProductDataTable = (props: ProductDataTableProps) => {
  //console.log('Rendering ProductDataTable', props)
  const { locale } = useContext(PageContext)
  const t = useDatoMicrocopy("product", locale)
  const getProductPath = useProductPath()

  const singleProduct = false // = props.products.length == 1

  //const values = getCompareValues(props.products, props.keys)

  const values = props.values

  if (!values || !values.length) return null

  return (
    <div className={styles.container + " table-container"}>
      <table className={singleProduct ? styles.singleProduct : undefined}>
        {!singleProduct && (
          <thead>
            <tr>
              <th>{t("compareModel", "Model").toUpperCase()}</th>
              {props.products.map(product => {
                const path = getProductPath(product.identifier)
                return (
                  <th key={`thead${product.identifier}`}>
                    <a href={path}>{product.identifier}</a>
                  </th>
                )
              })}
            </tr>
          </thead>
        )}

        <tbody>
          {values.map((itms, i) => {
            return (
              <tr key={itms.name}>
                <th style={{ fontWeight: 600 }}>{itms.label}</th>

                {itms.value.map((itm, j) => {
                  return <td key={j}>{itm ? <ProductAttribute list={itm.value} /> : <>&nbsp;</>}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default ProductDataTable
